// extracted by mini-css-extract-plugin
module.exports = {"container":"Yf-z","copy":"Zf-z","field":"_f-z","error":"ag-z","disabled":"bg-z","termsContainer":"cg-z","termsHeading":"dg-z","termsCopy":"eg-z","submit":"fg-z","srOnly":"gg-z"};